import { Card, Container } from '~/design-system/primitives'
import { Info } from '~/icons'

export default function Header() {
  return (
    <header className="bg-white drop-shadow-sm py-4 md:py-5 flex flex-col">
      <Container className="flex flex-row justify-between">
        <a className="inline-block" href="/">
          <img alt="Logo Swift" src="/icons/logo-primary.svg" />
        </a>
        <Card className="flex flex-row gap-2 items-center p-0 m-0 w-fit">
          <Info className="fill-gray-40" />
          <span>Estamos mudando nossa experiência de compra, para você, em primeira mão!</span>
        </Card>
      </Container>
    </header>
  )
}
